export interface ActivityData {
    year: number,
    activities: ActivityInfo[]
  }
  
export class ActivityInfo {
    id = 0;
    translationKey?: string;
    images: string[] = [];
  }